import { createSelector } from 'reselect';

import { createParameterSelector } from '@pressreader/appstore';
import { selectGetConfigValue } from '@pressreader/config';
import { COLLECTION_IS_PRIVATE_DEFAULT } from '@pressreader/social-types';

const publicCollectionsFeatureFlagPath = 'features.app.popups.edit_bookmark.publicCollections.enable';

const selectIsCurrentChannelPrivateParam = createParameterSelector<'isCurrentChannelPrivate', boolean>('isCurrentChannelPrivate');

const selectPublicCollectionsEnabled = createSelector(
    selectGetConfigValue,
    getConfigValue => <boolean>getConfigValue(publicCollectionsFeatureFlagPath) ?? !COLLECTION_IS_PRIVATE_DEFAULT,
);

const selectShowPublicCollectionToggleFrom = createSelector(
    selectPublicCollectionsEnabled,
    selectIsCurrentChannelPrivateParam,
    (isPublicCollectionsEnabled, isCurrentChannelPrivate) => isPublicCollectionsEnabled && !isCurrentChannelPrivate,
);

export { selectPublicCollectionsEnabled, selectShowPublicCollectionToggleFrom };
